<template>
  <div class="mobile_scene">
    <div id="Swip" ref="swiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="(item, index) in applicationInfo"
          :key="index"
          class="swiper-slide"
        >
          <img :src="item.imgUrl" alt="" />
          <div class="swiper_text">
            <p style="margin-bottom: 11px; font-size: 20px; font-weight: 700;" class="swiper_text_p">{{ item.title }}</p>
            <p style="font-size: 11px; font-weight: 300;" class="swiper_text_p1">{{ item.msg }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data() {
    return {
    };
  },
  props: {
    applicationInfo: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 2000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: true,
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
</style>